import { render, staticRenderFns } from "./statusCell.vue?vue&type=template&id=8d8b452c&scoped=true"
import script from "./statusCell.vue?vue&type=script&lang=js"
export * from "./statusCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8b452c",
  null
  
)

export default component.exports